import React from "react";
import { default as WBottomNavigationAction } from "@mui/material/BottomNavigationAction";

function BottomNavigationAction(props) {
  return <WBottomNavigationAction {...props} />;
}

export default BottomNavigationAction;
